import { MODAL_STATE, ModalKey } from '../../types/modals'

type LinkType = 'link' | 'modal'

export interface Link {
    key: string
    title: string
    destination?: string
    onClickKey?: ModalKey
    type: LinkType
}

export const getContentLinks = (t: (key: string) => string): Link[] => [
    {
        key: 'home',
        title: t('footer.links.home'),
        destination: '/',
        type: 'link',
    },
    {
        key: 'how-it-works',
        title: t('footer.links.howItWorks'),
        destination: '/#how-it-works',
        type: 'link',
    },
    {
        key: 'sports',
        title: t('footer.links.sports'),
        destination: '/#sports',
        type: 'link',
    },
    {
        key: 'events',
        title: t('footer.links.events'),
        destination: '/#events',
        type: 'link',
    },
]

export const getCommunityLinks = (t: (key: string) => string): Link[] => [
    {
        key: 'tournaments',
        title: t('footer.links.tournaments'),
        destination: '/tournaments',
        type: 'link',
    },
    {
        key: 'community',
        title: t('footer.links.community'),
        destination: '/#community',
        type: 'link',
    },
    {
        key: 'faq',
        title: t('footer.links.faq'),
        destination: '/#faq',
        type: 'link',
    },
]

export const getDocLinks = (t: (key: string) => string): Link[] => [
    {
        key: 'privacy-website',
        title: t('footer.links.privacy'),
        destination: '/privacy',
        type: 'link',
    },
    {
        key: 'imprint',
        title: t('footer.links.imprint'),
        destination: '/imprint',
        type: 'link',
    },
    {
        key: 'event-rules',
        title: t('footer.links.eventRules'),
        destination: '/event-rules',
        type: 'link',
    },
    {
        key: 'terms',
        title: t('footer.links.terms'),
        destination: '/terms',
        type: 'link',
    },
    {
        key: 'manage-cookies',
        title: t('footer.links.manageCookies'),
        onClickKey: MODAL_STATE.COOKIE_CONSENT,
        type: 'modal',
    },
]

export const getAboutLinks = (t: (key: string) => string): Link[] => [
    {
        key: 'about-us',
        title: t('footer.links.aboutUs'),
        destination: '/about',
        type: 'link',
    },
    {
        key: 'contact-us',
        title: t('footer.links.contactUs'),
        onClickKey: MODAL_STATE.CONTACT_US,
        type: 'modal',
    },
]
